import ToastHighLighter from '@/lib/ToastHighLighter';

export const TeaserCode = () => {
  const language = 'html';
  const codeString = `
  // Teaser - three columns example
  <div class="teaser card mb-4 col-xs-12 col-sm-6 col-lg-4 p-0">
    <a href="#" title="">
      <div class="card-body">
        <div class="position-relative">
          <img src="" alt="" aria-hidden="true" class="img-fluid w-100" />
        </div>
        <small class="d-inline-block mb-2">Teaser subtitle</small>
        <h2 class="card-title no-line">Teaser title</h2>
        <p>Teaser content</p>
      </div>
    </a>
  </div> 

  // Teaser - four columns example
  <div class="teaser card mb-4 col-xs-12 col-sm-6 col-lg-3 p-0">
    <a href="#" title="">
      <div class="card-body">
        <div class="position-relative">
          <img src="" alt="" aria-hidden="true" class="img-fluid w-100" />
        </div>
        <small class="d-inline-block mb-2">Teaser subtitle</small>
        <h2 class="card-title no-line">Teaser title</h2>
        <p>Teaser content</p>
      </div>
    </a>
  </div> 
`;

  return (
    <>
      <ToastHighLighter
        name={'table'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
